<template>
	<div class="agreement2 no-trans" v-loading="loading">
		 <!-- {{ detials }} -->

		<el-dialog :title="detials.title" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
			<div class="htmls">
				<div v-html="detials.content"></div>
			</div>
		</el-dialog>

	</div>
</template>
<script>
	 
 
	export default {
		components: {
			 
		},
		name: "index",
		data() {
			return {
				detials:{},
				dialogVisible:false
			}
		},
		computed: {
			 
		},
		watch: {
			 
		},
		created() {
		},
		methods: {

			handleClose(){
						this.dialogVisible=false
			},
            get_detial(id){
                this.loading=true
                this.$api("getArticle", {
                    id:id,
                }, "get").then((res) => {
                    this.loading = false
                    console.log('新闻详情1',res)
					this.loading=false
                    if (res.code == 1) {
                        this.detials=res.data
						this.dialogVisible=true
                    } else {
                        alertErr(res.msg)
                    }
                });
            },
		 
			 



		},

	}
</script>
<style scoped lang="less">
	.agreement2 {
		width: 100%;
		height: 100vh;
		padding:32px;
		.htmls{
			height: 600px;
			overflow: auto;
		}

	}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .agreement2.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        height: auto;
        min-height: 0;
        padding: 0;
    }
    .agreement2.no-trans .htmls {
        min-height: 0;
        height: auto;
    }
}
</style>
